module.exports = __webpack_public_path__ + "media/question2_en.8f337dc9.mp3";